var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNoMenu = function SvgIconNoMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{fill:#8798ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7792 1035)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 80,
    height: 80,
    rx: 4,
    transform: "translate(7792 -1035)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 48,
    height: 48,
    transform: "translate(7808 -1019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10987.295-19308.293a.992.992,0,0,1,0-1.412l38-38a1,1,0,0,1,1.418,0,1,1,0,0,1,0,1.414l-38,38a1,1,0,0,1-.709.293A.993.993,0,0,1,10987.295-19308.293Zm10.712-6.473,1.442-1.441a13.938,13.938,0,0,0,7.55,2.205,13.931,13.931,0,0,0,9.9-4.1,13.9,13.9,0,0,0,4.1-9.9,13.932,13.932,0,0,0-2.2-7.551l1.442-1.441A15.947,15.947,0,0,1,11023-19328a15.9,15.9,0,0,1-4.686,11.314A15.9,15.9,0,0,1,11007-19312,15.922,15.922,0,0,1,10998.007-19314.766Zm-4.244-4.248A15.9,15.9,0,0,1,10991-19328a15.885,15.885,0,0,1,4.686-11.309A15.885,15.885,0,0,1,11007-19344a15.934,15.934,0,0,1,8.993,2.764l-1.442,1.441a13.937,13.937,0,0,0-7.551-2.2,13.921,13.921,0,0,0-9.9,4.1,13.926,13.926,0,0,0-4.1,9.9,13.933,13.933,0,0,0,2.205,7.551l-1.442,1.438v0Zm18.68-4.156-3.617-2.414,1.438-1.441,3.292,2.2a.987.987,0,0,1,.428.631,1,1,0,0,1-.151.752,1.007,1.007,0,0,1-.835.447A.994.994,0,0,1,11012.442-19323.17Zm-6.443-8.076V-19336a1.172,1.172,0,0,1,1-1.287,1.172,1.172,0,0,1,1,1.287v2.764l-2,1.994v.006Z",
    transform: "translate(-3175 18333)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNoMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-noMenu.3b5a6851.svg";
export { ForwardRef as ReactComponent };